import Fetcher from '../../../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../../constants'
import { CommunityData, CommunityDetailsRequest, GpoDetailsData } from './types'

const fetcher = new Fetcher({})

export const getCommunityDetails = async (id, params) =>
  fetcher.request<CommunityDetailsRequest, CommunityData>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.COMMUNITIES}${id}/`,
    method: HTTP_METHODS.GET,
    params
  })

export const getGpoDetails = async (id) =>
  fetcher.request<unknown, GpoDetailsData>({
    url: `${API_DICTIONARY.MY_COMMUNITY}${API_DICTIONARY.GPO}${id}/`,
    method: HTTP_METHODS.GET
  })
